<template>
  <div class="simple-keyboard"/>
</template>

<script>
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';

export default {
  name: 'SimpleKeyboard',
  data() {
    return {
      keyboard: null
    };
  },
  mounted() {
    this.keyboard = new Keyboard({
      onKeyPress: this.onKeyPress,
      preventMouseDownDefault: true
    });
  },
  beforeDestroy() {
    this.keyboard && this.keyboard.destroy();
  },
  methods: {
    onKeyPress(button) {
      if (button === '{space}') {
        button = ' ';
      }
      const active = document.activeElement;
      if (active.tagName.toLowerCase() !== 'input') {
        return;
      }
      const vuetifyTextField = active.parentElement.parentElement.parentElement.parentElement.__vue__;
      if (!button.includes('{')) {
        if (vuetifyTextField.internalValue === null || vuetifyTextField.internalValue === undefined) {
          vuetifyTextField.internalValue = button;
        } else {
          vuetifyTextField.internalValue += button;
        }
        return;
      }
      if (button === '{bksp}') {
        const v = vuetifyTextField.internalValue;
        const start = active.selectionStart;
        const end = active.selectionEnd;
        vuetifyTextField.internalValue = v.substr(0, start - 1) + v.substr(end);
        setTimeout(() => active.setSelectionRange(start - 1, start - 1), 0);
        return;
      }
      if (button === '{shift}' || button === '{lock}') {
        this.handleShift();
      }
    },
    handleShift() {
      const currentLayout = this.keyboard.options.layoutName;
      const shiftToggle = currentLayout === 'default' ? 'shift' : 'default';

      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.simple-keyboard {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
}

.simple-keyboard >>> .hg-button {
  height: 50px;
}
</style>
